exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconbadge[data-v-7f17524c]{border-radius:2.5em!important;height:72px;width:72px;pointer-events:none}", ""]);

// exports
